export const CRUD_LOOKUP_TABLES = [];

export const THEME = {
  MAIN_SIDEBAR_WIDTH: 258,
  DATETIME_FORMAT_SHORT: "MM/dd/yyyy hh:mm a",
  DATE_FORMAT_LONG: "MMM D YYYY, HH:mm A",
  DATE_FORMAT_SHORT: "MM/dd/yyyy",
  TIME_FORMAT_LONG: "hh:mm:ss a",
  TIME_FORMAT_SHORT: "hh:mm a",
};

export const ROUTES = {
  HOME: "/",
  ACCESSIBILITY: "/accessibility",
  TIME_SERIES_COMPARISON: "/explore/time-series-comparison",
  STREAMFLOW_DATA: "/explore/stream-logger-data",
  PRECIPITATION: "/explore/precipitation",
  PRF_PERFORMANCE: "/explore/prf-performance",
  PRF_STATISTICS_TOOL: "/explore/prf-statistics-tool",
  YEAR_COMPARISON_GRAPH: "/explore/year-comparison-graph",
  CORRELATION_GRAPH: "/explore/correlation-graph",
  WATER_QUALITY_PARAMETER_VIEWER:
    "/water-quality-update/water-quality-parameter-viewer",
  CCR_INFLOW_CONCENTRATIONS: "/water-quality-update/ccr-inflow-concentrations",
  WQ_INFLOW_COMPARISON: "/water-quality-update/wq-inflow-comparison",
  FIELD_DEPTH_PROFILE: "/water-quality-update/field-depth-profile",
  CONTINUOUS_TEMPERATURE_PROFILE:
    "/water-quality-update/continuous-temperature-profile",
  NUTRIENT_RATIOS: "/water-quality-update/nutrient-ratios",
  MAP: "/tools/map",
  // the map page opened directly in its water quality (graph) view
  MAP_WATER_QUALITY: "/tools/map?mode=wq",
  DOWNLOAD: "/tools/download",
  SITE_SUMMARY_TABLE: "/tools/site-summary-table",
  IMPORT: process.env.REACT_APP_IMPORT_URL || "https://import.ccbwqportal.org/",
  MHFD_FLOOD_ALERT: "https://mhfd-ns5data.trilynx-novastar.systems/LDAD/GMap/#",
  RESERVOIR_ELEVATION:
    "https://water.usace.army.mil/overview/nwo/locations/chcr",
  LOGOUT: "/auth/logout",
  MAP_IFRAME: "/data-access/public-map-i-frame",
  PAP_MAP_IFRAME: "/data-access/public-map-i-frame-pap",
  // Annual Report Visualization Embeds
  ANNUAL_REPORT_CONCENTRATIONS: "/annual-report-visualizations/concentrations",
  ANNUAL_REPORT_RESERVOIR_SUMMARY:
    "/annual-report-visualizations/reservoir-water-quality-summary",
  ANNUAL_REPORT_DEPTH_PROFILE:
    "/annual-report-visualizations/reservoir-depth-profile",
  ANNUAL_REPORT_NUTRIENT_RATIOS:
    "/annual-report-visualizations/nutrient-ratios",
  ANNUAL_REPORT_INFLOW_COMPARISONS:
    "/annual-report-visualizations/reservoir-inflow-comparisons",
  ANNUAL_REPORT_YEAR_COMPARISON:
    "/annual-report-visualizations/year-comparison",
  ANNUAL_REPORT_CORRELATION_GRAPH:
    "/annual-report-visualizations/correlation-graph",
  ANNUAL_REPORT_SEASONAL_MEAN: "/annual-report-visualizations/seasonal-mean",
  ANNUAL_REPORT_STREAMFLOW_DATA:
    "/annual-report-visualizations/streamflow-data",
  UPSTREAM_DOWNSTREAM: "/explore/upstream-to-downstream",
  ANNUAL_REPORT_UPSTREAM_DOWNSTREAM:
    "/annual-report-visualizations/upstream-to-downstream",
  WQ_SCORECARD: "/water-quality-update/wq-scorecard",
  ANNUAL_REPORT_WQ_SCORECARD: "/annual-report-visualizations/wq-scorecard",
  CLIMATE_MONTHLY: "/explore/monthly-climate",
  ANNUAL_REPORT_CLIMATE_MONTHLY:
    "/annual-report-visualizations/monthly-climate",
};
